module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}
;